<template lang="pug">
#modal-login.modal.fade(tabindex='-1' role='dialog')
  //- #preloader(v-if="loading")
    #loader
  .modal-dialog.modal-dialog-centered.my-0.modal-form
    .modal-content-outside
      .modal-content
        //- .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(onclick='location.href='index.html'')
        .modal-header.justify-content-start.align-items-center.p-2.border-bottom-0(data-dismiss='modal')
          .arrow-left
            i.fas.fa-chevron-left
          .modal-title.text-capitalize home
        .d-none.d-md-block.lg-close(data-dismiss='modal')
          i.far.fa-times-circle
        .modal-body.px-4.mb-md-5.custom-flex
          .text-center
            .text-uppercase.modal-form-title {{$t('ui.login')}}
          .mx-auto.text-center.icon-user
            img(src='img/icon-user.png')
          form
            .input-group.mb-4
              label.px-2.input-field {{ $t("ui.username") }}
              input.text-center.rounded-pill.form-control(type='text' v-model.trim="$v.accId.$model" @keyup.enter="login")
              //- .required
                i.fas.fa-exclamation-circle
              //- .text-center.w-100.text-danger Login ID required
              validation(:value="$v.accId" :name="$t('ui.username')" target="LOGIN")
            .input-group.mb-4
              label.px-2.input-field {{ $t("ui.password") }}
              input.text-center.rounded-pill.form-control(type="password" v-model.trim="$v.accPw.$model" @keyup.enter="login")
              //- .text-center.w-100.text-danger Please enter password
              validation(:value="$v.accPw" :name="$t('ui.password')" target="LOGIN")
            .text-center(v-if="!loading")
              .d-inline-block(@click="login")
                .btn.rounded-pill.text-uppercase.btn-main {{$t('ui.login')}}
            .text-center(v-else)
              .d-inline-block
                .btn.rounded-pill.text-uppercase.btn-main.disabled-grey
                  i.fas.fa-sync.fa-spin
        input(type="hidden" id="IP" name="IP" value="")
        //- .p-2.modal-login-footer
          .d-flex.justify-content-between
            a(href='#' data-dismiss='modal' data-toggle='modal' data-target='#modal-signup') No Accout Yet?
            a(href='#' data-dismiss='modal' data-toggle='modal' data-target='#modal-forgotpw') Forgot Password?
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import validation from "@/library/_validation.vue"
export default {
  components: {
    validation
  },
  data(){
    return{
      accId: "",
      accPw: "",
      ipAdd: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    }
  },
  validations:{
    accId:{
      required,
    },
    accPw:{
      required,
    },
  },
  mounted(){
    let vm = this
    $('#modal-login').on('shown.bs.modal', function (e) {
      $('#username').trigger('focus')
      vm.reset();
    })
  },
  methods:{
    verify() {
      this.$v.$touch()
      var vm = this
      if (!this.$v.$invalid) {
        $.getJSON("https://api.ipify.org?format=jsonp&callback=?",
          function(json) {
            // console.log(json.ip);
            vm.ipAdd = json.ip
            vm.login()
          }
        )     
      }
    },
    login(){
      this.loading = true
      let login_id = this.accId
      let password = this.accPw
      var vm = this
      if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
        var login_source = "Mobile"
      }else{
        var login_source = "Web"
      }
      this.$store
        .dispatch("user/login", { login_id, password, login_source })
        .then(response => {
          this.loading = false;
          this.feedback.success = response.success
          if (this.feedback.success == true) {
            this.getPromo()
            // let refreshKey = this.$store.getters.refreshKey + 1
            // this.$store.dispatch("user/setRefreshKey", refreshKey)
            this.reset()
            // $('#modal-login').modal('hide')
            // $('body').removeClass('modal-open')
            // $('.modal-backdrop').remove()
            // $(".overlay").removeClass("d-block")
            // this.$router.push("/").catch(error =>{})
          } else {
            var vm = this
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
            }        
          }
        })
        .catch(response => {
          this.loading = false;
          var vm = this
          if((typeof response.status) != 'object'){
            this.$helpers.showDialog(vm.$tc("ui.attention"), vm.$tc("message.list." + response.status), "info", this)
          }
              
        });
    },
    getPromo(){
      if (this.sessionToken) {
        let member_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getPromo", { member_id, auth_token })
          .then(response => {
            if (response.success == true) {
              this.$store
                .dispatch("user/sPromo", { data: response.data })
                .then(() => {
                  // let refreshKey = this.$store.getters.refreshKey + 1
                  // this.$store.dispatch("user/setRefreshKey", refreshKey)
                  this.reset()
                  $('#modal-login').modal('hide')
                  $('body').removeClass('modal-open')
                  $('.modal-backdrop').remove()
                  $(".overlay").removeClass("d-block")
                  this.$router.push("/").catch(error =>{})
                })
                .catch(err => console.log(err))
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {console.log(response)
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    reset(){
      this.username = ""
      this.password = ""
      this.$v.$reset();
    }
  }
}
</script>